import React, { useState, useEffect } from "react";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LoginPage.css";
import Footer from "./Footer";

// Function to detect in-app browser
const detectInAppBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
        userAgent.includes('wv') || // Android WebView
        userAgent.includes('instagram') || // Instagram
        userAgent.includes('fbav') || // Facebook
        userAgent.includes('twitter') || // Twitter
        userAgent.includes('x-') || // X (Twitter) new format
        userAgent.includes('linkedin') || // LinkedIn
        userAgent.includes('whatsapp') || // WhatsApp
        userAgent.includes('telegram') || // Telegram
        userAgent.includes('line') || // Line
        userAgent.includes('kakaotalk') || // KakaoTalk
        userAgent.includes('snapchat') || // Snapchat
        userAgent.includes('pinterest') || // Pinterest
        userAgent.includes('tiktok') || // TikTok
        userAgent.includes('wechat') || // WeChat
        userAgent.includes('reddit') || // Reddit
        userAgent.includes('reddit-app') || // Reddit App
        userAgent.includes('blind') || // Blind
        userAgent.includes('blind-app') || // Blind App
        userAgent.includes('discord') || // Discord
        userAgent.includes('slack') || // Slack
        userAgent.includes('zoom') || // Zoom
        userAgent.includes('teams') || // Microsoft Teams
        userAgent.includes('skype') || // Skype
        userAgent.includes('viber') || // Viber
        userAgent.includes('messenger') || // Messenger
        userAgent.includes('chrome') && !userAgent.includes('edg') && !userAgent.includes('opr') && !userAgent.includes('safari') // Chrome WebView
    );
};

// Export the handleGoogleSignIn function
export const handleGoogleSignIn = async (
  navigate,
  setLoading,
  setWasAnonymous = null
) => {
  setLoading(true);
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const token = await user.getIdToken();
    let databaseUid;
    let credits;
    let firebaseuid;
    let isNewUser;

    const baseURL =
      process.env.REACT_APP_ENVIRONMENT_TYPE === "DEV"
        ? "http://127.0.0.1:5000"
        : "https://flask-backend-52245432644.us-central1.run.app";
    const response = await axios.post(`${baseURL}/login-user`, { token });

    databaseUid = response.data.database_uid;
    credits = response.data.credits;
    firebaseuid = response.data.firebaseuid;
    isNewUser = response.data.isNewUser;
    if (setWasAnonymous) {
      setWasAnonymous(false);
    }

    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("databaseUid", databaseUid);
    localStorage.setItem("uid", databaseUid);
    localStorage.setItem("firebaseuid", firebaseuid);
    localStorage.setItem("credits", credits);

    const params = new URLSearchParams(window.location.search);
    const pid = params.get("pid");

    if (pid) {
      navigate(`/dashboard?pid=${pid}`);
    } else if (isNewUser) {
      // Redirect to Analyze page for new users
      navigate("/dashboard");
    } else {
      // Redirect to Screeners page for returning users
      navigate("/dashboard");
    }
  } catch (error) {
    console.error("Error during Google Sign-In:", error);
    alert(error.message);
  } finally {
    setLoading(false); // Set loading to false once sign-in completes
  }
};

// The rest of the LoginPage component
const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [wasAnonymous, setWasAnonymous] = useState(false);
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);

  useEffect(() => {
    setIsInAppBrowser(detectInAppBrowser());
  }, []);

  const signIn = () => {
    handleGoogleSignIn(navigate, setLoading, setWasAnonymous);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">MarketCrunch AI&#8482;</h1>
          <p className="login-subtitle">
            Free AI-driven Research and Prediction. <br /> No credit card
            needed.
          </p>
        </div>

        {isInAppBrowser ? (
          <div className="in-app-browser-warning">
            <h2>⚠️ In-App Browser Detected</h2>
            <p>We've detected that you're using an in-app browser. For the best experience and to ensure proper functionality:</p>
            <ol>
              <li>Open this link in your device's default browser</li>
              <li>Or copy and paste this URL into your browser</li>
            </ol>
            <div className="url-box">
              {window.location.href}
            </div>
            <button 
              className="copy-button"
              onClick={() => {
                navigator.clipboard.writeText(window.location.href);
                alert('URL copied to clipboard!');
              }}
            >
              Copy URL
            </button>
          </div>
        ) : (
          <>
            {!loading ? (
              <button className="login-button" onClick={signIn}>
                <img
                  src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                  alt="Google Icon"
                  className="google-icon"
                />
                Continue with Google
              </button>
            ) : (
              <p>Loading...</p>
            )}
          </>
        )}

        {wasAnonymous && (
          <div className="anon-indicator">
            <p>
              You were previously an anonymous user. Your data has been updated.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
